/* eslint-disable */
import DrupalPage from "./DrupalPage";
/* eslint-enable */

export default DrupalPage;
